export default __webpack_public_path__ + "static/media/default.8b81e3d04e079fec067ca63c2b65c977.png";